import React from 'react';
import { fromThemeColors, layout, Theme, ThemeColor } from '@citrite/web-ui-component';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useIsDetailedDesktopTileEnabled } from 'Configuration/hooks';
import { useFormFactor } from './useFormFactor';

interface Props {
	children: JSX.Element | JSX.Element[];
}

const StyledDivLegacy = styled.div<{
	theme: Theme;
	isLargeFormFactor: boolean;
}>`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid ${fromThemeColors(ThemeColor.border)};
	${props => `
		background-color: ${props.theme.branding.styles.HeaderBackgroundColor};
		color: ${props.theme.branding.styles.HeaderTextColor}; 
	`}
	${props =>
		props.isLargeFormFactor
			? `padding: ${layout.space12} ${layout.space32};`
			: `padding: ${layout.space4} ${layout.space14};`}
`;

const StyledDivDetailed = styled(StyledDivLegacy)`
	padding: ${layout.space12} ${layout.space20};
`;

export const Banner: React.FC<Props> = props => {
	const theme = useTheme();
	const { isLargeFormFactor } = useFormFactor();
	const isDetailedDesktopTileEnabled = useIsDetailedDesktopTileEnabled();
	const StyledDiv =
		isDetailedDesktopTileEnabled && isLargeFormFactor
			? StyledDivDetailed
			: StyledDivLegacy;
	return (
		<StyledDiv
			theme={theme}
			data-testid="application-banner"
			isLargeFormFactor={isLargeFormFactor}
		>
			{props.children}
		</StyledDiv>
	);
};
